let lastPlayedAt = 0;

export function playNotificationSound(): void {
  if (typeof window === "undefined") return;

  const now = Date.now();
  if (now - lastPlayedAt < 500) return;
  lastPlayedAt = now;

  try {
    const AudioContextClass =
      window.AudioContext ||
      (window as Window & { webkitAudioContext?: typeof AudioContext })
        .webkitAudioContext;
    if (!AudioContextClass) return;

    const ctx = new AudioContextClass();

    const playTone = (
      frequency: number,
      startTime: number,
      duration: number,
    ) => {
      const oscillator = ctx.createOscillator();
      const gain = ctx.createGain();
      oscillator.type = "sine";
      oscillator.frequency.value = frequency;
      gain.gain.setValueAtTime(0.0001, startTime);
      gain.gain.exponentialRampToValueAtTime(0.12, startTime + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, startTime + duration);
      oscillator.connect(gain);
      gain.connect(ctx.destination);
      oscillator.start(startTime);
      oscillator.stop(startTime + duration);
    };

    const start = () => {
      const t = ctx.currentTime;
      playTone(880, t, 0.12);
      playTone(1108.73, t + 0.12, 0.2);
      window.setTimeout(() => void ctx.close(), 600);
    };

    if (ctx.state === "suspended") {
      void ctx.resume().then(start);
    } else {
      start();
    }
  } catch {
    // Autoplay restrictions or unsupported environment — ignore silently
  }
}
